import { render, staticRenderFns } from "./PopupEdit.vue?vue&type=template&id=1fb88888&"
import script from "./PopupEdit.vue?vue&type=script&lang=js&"
export * from "./PopupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPopupEdit});
